import { render, staticRenderFns } from "./ScanBottomNav.vue?vue&type=template&id=4853dc6c&scoped=true&"
import script from "./ScanBottomNav.vue?vue&type=script&lang=js&"
export * from "./ScanBottomNav.vue?vue&type=script&lang=js&"
import style0 from "./ScanBottomNav.vue?vue&type=style&index=0&id=4853dc6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4853dc6c",
  null
  
)

export default component.exports